import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colors } from 'utils/colors';
import { RiskProfilesListMap } from './RiskProfilesListMap';

function RiskPortfoliosList({
  portfolios,
  handlePortfolioChange,
  selectedPortfolio,
  recommendedPortfolio,
}) {
  return (
    <RadioGroup>
      {portfolios.map((port) => {
        const isSelected = port.name === selectedPortfolio;
        const isRecommended = port.name === recommendedPortfolio;
        return (
          <CardWrapper
            key={port.id}
            selected={isSelected}
            onClick={(e) =>
              handlePortfolioChange(e, {
                value: port.id.toString(),
                name: port.name,
              })
            }
          >
            {isRecommended && <RecBadge>RESULT</RecBadge>}
            <PortfolioName selected={isSelected}>
              {RiskProfilesListMap[port.name].riskName}
            </PortfolioName>
            <RiskLabel>{RiskProfilesListMap[port.name].riskGeneric}</RiskLabel>
          </CardWrapper>
        );
      })}
    </RadioGroup>
  );
}
RiskPortfoliosList.propTypes = {
  portfolios: PropTypes.array.isRequired,
  handlePortfolioChange: PropTypes.func.isRequired,
  selectedPortfolio: PropTypes.string,
  recommendedPortfolio: PropTypes.string,
};

RiskPortfoliosList.defaultProps = {
  selectedPortfolio: '',
  recommendedPortfolio: '',
};

export default connect(() => ({}))(RiskPortfoliosList);

const RadioGroup = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;

const CardWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 160px;
  min-height: 72px;
  padding: 12px 10px;
  border-radius: 8px;
  border: 2px solid
    ${({ selected }) => (selected ? colors.navyBlue : '#d4d4d4')};
  background-color: ${({ selected }) => (selected ? '#eeeef9' : '#ffffff')};
  text-align: center;
  user-select: none;
  transition: border-color 0.15s, background-color 0.15s;
  &:hover {
    border-color: ${({ selected }) => (selected ? colors.navyBlue : '#aaaaaa')};
  }
`;
const RecBadge = styled.div`
  position: absolute;
  top: -11px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${colors.navyBlue};
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
`;

const PortfolioName = styled.div`
  font-size: 14px;
  font-weight: ${({ selected }) => (selected ? '700' : '600')};
  color: #1a1a1a;
  margin-bottom: 4px;
`;

const RiskLabel = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.55);
`;
